import React, { useState, useCallback, useRef } from "react";
import { StaffFrame, ProgrammerView, Toast } from "./DashboardShared";

export default function ProgrammerPage() {
  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);
  const showToast = useCallback((msg, type = "error") => {
    if (toastTimer.current) clearTimeout(toastTimer.current);
    setToast({ msg, type });
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  }, []);

  return (
    <StaffFrame>
      <Toast toast={toast} />
      <div className="topbar">
        <div>
          <div className="topbar-title">Horaires & Trajets</div>
          <div className="topbar-sub">Créez, modifiez et gérez les trajets</div>
        </div>
      </div>
      <ProgrammerView showToast={showToast} />
    </StaffFrame>
  );
}
